import axios from "axios";

export const getBackendUrl = () => {
  if (typeof window !== "undefined" && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
    return window.location.origin;
  }
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
  }
  return "http://localhost:8001";
};

const PUBLIC_STATIC_ASSETS = ["/hero-bg.webp", "/hero-bg.jpg", "/sebastian-ferradas.jpg", "/logo-sfr.png", "/favicon.ico"];

export const getImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;

  if (PUBLIC_STATIC_ASSETS.includes(url)) {
    return url;
  }

  if (url.startsWith("http://") || url.startsWith("https://")) {
    if (typeof window !== "undefined" && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
      return url.replace(/http:\/\/localhost:(8001|3000)/g, "https://ferradas.cocoand.com");
    }
    return url;
  }
  const base = getBackendUrl();
  return `${base}${url.startsWith("/") ? "" : "/"}${url}`;
};

const api = axios.create({
  baseURL: `${getBackendUrl()}/api`,
  withCredentials: true,
});

export const uploadImageHelper = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  if (res.data && typeof res.data === "object" && res.data.url) {
    return getImageUrl(res.data.url);
  }
  throw new Error("No se pudo subir la imagen. Verifique la conexión con el servidor backend.");
};

export default api;
